import OptionsStore from '../../../../stores/OptionsStore';
import { OPTION_KEYS, ORGANIZATION_TYPES } from '../../../../utils/constants';

export function getLienholderOptions (getOptions: OptionsStore['getOptions']) {
  const organizationTypes = getOptions(OPTION_KEYS.LEGAL_ORGANIZATION_TYPE);

  return organizationTypes.filter(({ value }) => value !== ORGANIZATION_TYPES.LAW_FIRM);
}
